import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { intlFormat } from 'date-fns';
import { cloneDeep } from 'lodash';
import { Observable } from 'rxjs';

@Injectable()
export class DateInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    let reqClone = cloneDeep(request);

    if (reqClone.body) {
      const body: { [key: string]: any } = reqClone.body;

      for (const key in body) {
        if (body[key] instanceof Date) {
          const date = new Date(body[key]);
          body[key] = intlFormat(date, { locale: 'en-US' });
        }
      }
    }

    return next.handle(reqClone);
  }
}
